import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const MarshallIslands: Country = {
    identifier: "MarshallIslands",
    name: "Marshall Islands",
    countryCode: "MH",
    group: CountryGroup.OCEANIA,
    isUNMember: true,
    flag: "🇲🇭",
    svgPath: "m 943.27075,431.6294 -0.073,0.02 -0.055,-0.02 0.04,-0.037 0.082,-0.006 0.031,0.01 -0.025,0.033 z m 5.445,10.861 -0.041,0.043 -0.271,-0.026 -0.124,-0.054 0.012,-0.041 0.214,0.039 0.21,0.039 z m 6.375,0.48 0.352,0.144 0.468,-0.067 -0.075,0.043 -0.175,0.04 -0.116,0.035 -0.078,0 -0.093,-0.014 -0.3,-0.1 -0.168,-0.132 0.041,-0.044 0.144,0.095 z m 1.334,0.253 0.104,0.061 0.207,-0.004 0.191,0.155 -0.073,-0.01 -0.104,-0.066 -0.095,-0.028 -0.128,0.008 -0.06,-0.025 -0.042,-0.091 z m -5.451,3.418 -0.056,0.084 -0.069,-0.006 0.061,-0.063 0.042,-0.088 0.067,-0.25 0.139,-0.089 0.096,-0.104 -0.023,0.108 -0.15,0.113 -0.107,0.295 z",
}
